'use client';

var translations = {
    'Upload file from your device': 'Chọn hồ sơ từ máy của bạn',
    '.doc, .docx and .pdf files that are less than 5120KB in size': 'Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB',
    or: 'hoặc',
    'Choose file to upload': 'Chọn hồ sơ từ máy bạn',
    'Drag your file here': 'Kéo hồ sơ của bạn vào đây',
    'Upload success': 'Tải lên thành công',
    'Replace file': 'Thay thế hồ sơ',
    'Your upload was successful': 'Tải lên thành công',
    'Drag & drop your CV here to quickly create your profile with AI': 'Kéo thả CV của bạn để tạo nhanh hồ sơ với AI'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
